// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText___ujbw","overflowing":"ReadFullNote_overflowing__3usYY"};